document.addEventListener("DOMContentLoaded", (e) => {
    const children_arrows = document.querySelectorAll(
        ".menu-item-arrow-has-children"
    );
    Object.values(children_arrows).forEach((el) => {
        el.addEventListener("click", goToChildMenu);
    });

    function goToChildMenu(event) {
        const arrow = event.target;
        const li_tag = arrow.closest("li");
        li_tag.querySelector(".sub-menu-container").classList.add("opened");
    }

    // To Parent menu

    const parent_arrows = document.querySelectorAll(".menu-goto-parent");
    Object.values(parent_arrows).forEach((el) => {
        el.addEventListener("click", goToParentMenu);
    });

    function goToParentMenu(event) {
        const arrow = event.target;
        const sub_container = arrow.closest(".sub-menu-container");
        sub_container.classList.remove("opened");
    }

    // Open / Close / Hamburger
    // On icon
    const hamburger_icon = document.querySelector(".burger-icon");
    hamburger_icon.addEventListener("click", openCloseMobileMenu);

    const body = document.querySelector("body");
    let scrollPosition = 0;

    function openCloseMobileMenu(event) {
        const menu_shell = document.querySelector(".site-top-menu-panel");
        if (menu_shell.classList.contains("opened")) {
            menu_shell.classList.remove("opened");
            hamburger_icon.classList.remove("opened");
            body.classList.remove("overflow");
            body.style.position = "";
            body.style.top = "";
            window.scrollTo(0, scrollPosition);
        } else {
            menu_shell.classList.add("opened");
            hamburger_icon.classList.add("opened");
            setUpMobileMenu();
            body.classList.add("overflow");
            scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            body.style.position = "fixed";
            body.style.top = `-${scrollPosition}px`;
            body.style.width = `100%`;
        }
    }

    // Start setup topmenu

    function setUpMobileMenu() {
        // -----------------------

        // const current_page_item = document.querySelector('ul.sub-menu .current_page_item');
        const current_page_item = document.querySelector(
            "ul.sub-menu .current-menu-item"
        );
        if (!current_page_item) {
            return;
        }
        const shell = current_page_item.closest(".sub-menu-container");
        shell.classList.add("opened");

        // -----------------------

        let item = shell;
        let sub_menu_container;
        let ok = true;

        // for (let i = 0; i < 5; i++) {
        while (!!ok) {
            // if (!ok) {
            //   continue;
            // }
            sub_menu_container = item.closest(".sub-menu-container");
            if (!sub_menu_container) {
                ok = false;
                break;
            }
            sub_menu_container.classList.add("opened");
            item = sub_menu_container.parentNode;
        }
    }

    function setWindowSizeCookie() {
        var width = window.innerWidth;
        document.cookie = "window_width=" + width + "; path=/";
    }

    // Call if reload or resize window
    window.onload = setWindowSizeCookie;
    window.onresize = setWindowSizeCookie;
});
